<template>
  <div class="collection">
    <h1 class="collection-title">{{ levelName }} class Memories</h1>
    <div class="collection-cardList">
      <div
        v-for="(item, index) in cardUrlList"
        :key="index"
        class="collection-cardList-card"
        :class="{ transparency: !item.is_collected }"
      >
        <img :src="item.image_url" @click="showPropsPopup(index,item)" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    levelName: {
      type: String,
      default: "A",
    },
    cardUrlList: {
      type: Array,
      default: () => [],
    },
    amount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      divWidth: "0px",
    };
  },
  methods: {
    showPropsPopup(index,item) {
      if (!item.is_collected) {
        return;
      }
      this.$emit("showPropsPopup", item);
    },
  },
};
</script>

<style lang="less" scoped>
h1 {
  margin: 0;
  padding: 0;
}
.transparency {
  opacity: 0.2;
}

.collection {
  box-sizing: border-box;
  padding-top: 2px;
  margin: 0 auto;
  width: 287px;
  height: 85px;
  background-image: url("~@/assets/images/YuliApp/block_bg_C.png");
  background-size: 100% 100%;
  margin-bottom: 2px;
  &-title {
    color: rgba(48, 33, 71, 1);
    font-size: 14px;
    font-weight: 400;
    font-family: "PingFang SC";
    text-align: center;
    line-height: 16.8px;

    margin-bottom: 10px;
  }
  &-cardList {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    &-card {
      width: 50px;
      height: 50px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
